import { useCallback } from 'react';
import { useMutation, gql } from '@apollo/react-hooks';
import { get } from 'lodash';
import type { DeleteManufacturerMutation } from '#/graphql/types';
import { deleteManufacturer } from '#/graphql/mutations';
import { GET_ASSET_PROPS_COUNTS } from '../../hooks/useAssetPropsCountsQuery';

const q = gql(deleteManufacturer);

const useManufacturerDelete = () => {
  const [mutation, result] = useMutation<DeleteManufacturerMutation>(q);
  const deleteManufacturer = useCallback(
    async (itemId: string) => {
      const response = await mutation({
        variables: {
          id: itemId,
        },
        refetchQueries: [{ query: GET_ASSET_PROPS_COUNTS }],
        awaitRefetchQueries: true,
      });

      return get(response, 'data.deleteManufacturer.data', undefined);
    },
    [mutation],
  );

  return { deleteManufacturer, result };
};

export default useManufacturerDelete;
